const INSTITUTION_SUFFIX_PATTERNS = [
  /\s+University of Applied Sciences(?:\s+\([^)]+\))?$/i,
  /\s+University of Technology(?:\s+\([^)]+\))?$/i,
  /\s+University of Arts?$/i,
  /\s+University$/i,
  /\s+Universitätsmedizin Berlin.*$/i,
] as const

export const MOBILE_MAP_MARKER_MAX_LENGTH = 18

export function truncateAtWordBoundary(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text
  }

  const slice = text.slice(0, maxLength).trimEnd()
  const lastSpace = slice.lastIndexOf(' ')

  if (lastSpace > maxLength * 0.55) {
    return `${slice.slice(0, lastSpace).trimEnd()}…`
  }

  return `${slice.trimEnd()}…`
}

/** Drops campus or building suffixes after an em dash, en dash, or hyphen separator. */
export function stripMapMarkerCampusSuffix(name: string): string {
  return name.replace(/\s+[—–-]\s+.*$/u, '').trim()
}

/** Short display label for map marker pills on narrow viewports. Full name stays in aria-label/title. */
export function formatMobileMapMarkerLabel(
  name: string,
  maxLength = MOBILE_MAP_MARKER_MAX_LENGTH,
): string {
  let label = stripMapMarkerCampusSuffix(name)

  const acronymMatch = label.match(/^(.+?)\s+\(([A-Z0-9][A-Z0-9-]{1,7})\)\s*$/)
  if (acronymMatch) {
    return acronymMatch[2]
  }

  for (const pattern of INSTITUTION_SUFFIX_PATTERNS) {
    label = label.replace(pattern, '').trim()
  }

  if (/^Charité\b/i.test(label)) {
    return 'Charité'
  }

  return truncateAtWordBoundary(label, maxLength)
}
